import React from 'react';
import {messages} from "../common/Translations";
import {injectIntl} from "react-intl";
import {toastr} from "react-redux-toastr";
import TreeEditorCompetencies from './TreeEditorCompetencies';
import CreateCategoryForm from "../categories/CreateCategoryForm";
import {bindActionCreators} from "redux";
import * as spinnerActions from '../../actions/spinnerActions';
import * as modalActions from "../../actions/common/modalActions";
import {connect} from "react-redux";
import * as competenciesTreeEditorActions from "../../actions/competenciesTreeEditorActions";
import PlaceholderTable from "../common/PlaceholderTable";
import PlaceholderError from "../common/PlaceholderError";
import WithResolvedPromises from "../common/WithResolvedPromises";

class TreeEditorCompetenciesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            portalId: 1,
            actions: this.getRequiredActions(),
            showTable: true,
        };
    }

    getRequiredActions() {
        return [
            this.props.actions.fetchCompetencies('administrer-kompetencer'),
        ]
    }

    onParentForNewCompetencySelected(id) {
        this.setState({parentId: id});
    }

    onNewNodeNameChange(name) {
        this.setState({name: name});
    }

    onNodeNameEdit(params) {
        this.props.actions.showSpinner();
        this.props.actions.updateCompetency('administrer-kompetencer', params)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.competenciesWebmasterComNameUpdated))
            });
    }

    onMovedNode(params) {
        this.props.actions.showSpinner();
        this.props.actions.updateCompetency('administrer-kompetencer', params)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.competenciesWebmasterComPosUpdated))
            });
        }

    onCreate() {
        if(this.state.name !== '') {
            this.props.actions.showSpinner();
            let params = {
                name: this.state.name,
                parentId: this.state.parentId
            };
            this.props.actions.addCompetency('administrer-kompetencer', params)
                .then(() => {
                    this.props.actions.hideSpinner();
                    toastr.success(this.props.intl.formatMessage(messages.competenciesWebmasterComCreated))
                });
            this.setState({showCreateModal: false});
        }
    }

    onDelete(id) {
        this.props.actions.showSpinner();
        this.props.actions.deleteCompetency('administrer-kompetencer', id)
            .then(() => {
                this.props.actions.hideSpinner();
                toastr.success(this.props.intl.formatMessage(messages.competenciesWebmasterComDeleted))
            })
            .catch(error => {
                this.props.actions.hideSpinner();
                toastr.error(error.message);
            });
    }

    render() {

        return (
            <WithResolvedPromises preloaderComponent={PlaceholderTable} promises={this.state.actions}
                                  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return (
                            this.state.showTable ? (<TreeEditorCompetencies
                    title={this.props.intl.formatMessage(messages.sideBarProfileItemAdministerCompetencies)}
                    subTitle=''
                    fetchedData={this.props.fetchedData}
                    onCreatedNode={this.onCreate.bind(this)}
                    onMovedNode={this.onMovedNode.bind(this)}
                    onDeletedNode={this.onDelete.bind(this)}
                    onSubmit={this.onCreate.bind(this)}
                    onNodeNameEdit={this.onNodeNameEdit.bind(this)}
                >
                    <CreateCategoryForm
                        onCategorySelected={this.onParentForNewCompetencySelected.bind(this)}
                        categories={this.props.fetchedData}
                        onNameChange={this.onNewNodeNameChange.bind(this)}
                        dataTypeName="competence"
                    />
                </TreeEditorCompetencies>
                                )
                                : <PlaceholderTable/>
                        )
                    }
                }
            </WithResolvedPromises>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        fetchedData: state.treeEditorCompetencies
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...modalActions,
                ...spinnerActions,
                ...competenciesTreeEditorActions
            },
            dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TreeEditorCompetenciesContainer));


// WEBPACK FOOTER //
// ./web/src/components/editors/TreeEditorCompetenciesContainer.jsx